import { ArrowLeftOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Col, Row, Tooltip } from "antd";

import { useNavigate } from "react-router-dom";

interface UtilHeaderProps {
  className: string;
  backText: string | null;
  onClick: any;
}

const defaultProps: UtilHeaderProps = {
  className: "",
  backText: null,
  onClick: null,
};

const UtilHeader = ({ className, backText, onClick }: UtilHeaderProps) => {
  const navigate = useNavigate();

  if (!onClick) {
    onClick = () => {
      navigate(-1);
    };
  }

  return (
    <Row className={`covr-header-util ${className}`} justify="space-between" align="middle">
      <Col>
        <Tooltip title="Back">
          <Button onClick={onClick} type="primary" shape="circle">
            <ArrowLeftOutlined type="circle" />
            {backText}
          </Button>
        </Tooltip>
      </Col>
      <Col>
        <Tooltip title="More">
          <Button onClick={onClick} type="primary" shape="circle">
            <MoreOutlined />
          </Button>
        </Tooltip>
      </Col>
    </Row>
  );
};

UtilHeader.defaultProps = defaultProps;

export default UtilHeader;
